<template>
  <div id="home" ref="appRef">
    <dv-loading v-if="loading">Loading...</dv-loading>
    <div v-else>
      <Header />
      <!--主体 -->
      <div class="main-outer">
        <div class="outer">
          <div class="left">
            <div class="video_s">
              <video
                class="v_class"
                style=""
                src="http://minio.xccity.cn:19000/witrural/video/gyz/ljw_video3.mov"
                controls
                poster="@/videoBook.png"
              ></video>
            </div>
            <div class="text_s">
              <marquee direction="up" class="mar" scrollamount="2">
                刘家湾隶属于湖北省十堰市武当西南岭区。 刘家湾 刘家湾(5张)
                美丽的刘家湾位于武当西南岭区，是丹江汉水支源，属草坪村盐池河镇管辖，这里气候宜人，风景秀丽，春季有樱花、杏花、桐树花，各色草木与绿色林形成醉人的自然花园，初夏的杜梋分外鲜红，这里有居有十户居民，改良了一道道递田，对面即是闻名的“叫花岩”“豹子洞”“大步寺”“关子岩沟”，以及环绕的“罗枪湾”小河。这里是名附其实的“自然岭区公园”。</marquee
              >
            </div>
          </div>
          <div class="right">
            <div class="top_s" @click="enterMain()"></div>
            <div class="bottom_s"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '@/styles/drawMixin'
import loadingMixin from '_u/loadingMixin'
import Header from '../../components/header.vue'
import { login } from '_s/service/api/home'
import { encrypt } from '_s/utils/encrypt'

export default {
  name: 'home',
  mixins: [drawMixin, loadingMixin],
  components: {
    Header,
  },
  data() {
    return {}
  },
  methods: {
    enterMain() {
      this.$router.push('/effect')
    },
    login() {
      const data = {
        username: encrypt('yx-gyz-ljwc'),
        password: encrypt('ljwc123456*'),
      }
      login(data).then((res) => {
        if (res.code === 200) {
          sessionStorage.setItem('token', res.result.token)
          sessionStorage.setItem('areacode', res.result.userInfo.areacode)
          sessionStorage.setItem('tenantId', res.result.userInfo.tenantId)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  mounted() {
    this.login()
  },
}
</script>

<style lang="scss">
#home {
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: left top;
  overflow: hidden;
  background: url('@/backPic.png');

  .main-outer {
    display: flex;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    width: 1920px;
    height: 1000px;

    .outer {
      width: 1530px;
      height: 650px;
      display: flex;
    }
    .left {
      width: 841px;
      height: 650px;

      .video_s {
        width: 841px;
        height: 473px;
        // background: url("../assets/videoBook.png");
        margin-top: 35px;
        .v_class {
          width: 841px;
          height: 473px;
        }
      }
      .text_s {
        width: 841px;
        height: 80px;
        margin-top: 30px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 44px;
        overflow: hidden;
        .mar {
          height: 80px;
        }
      }
    }
    .right {
      width: 841px;
      height: 650px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 30px;
      .top_s {
        width: 647px;
        height: 281px;
        margin-bottom: 20px;
        background: url('@/top.png');
        cursor: pointer;
      }
      .bottom_s {
        width: 647px;
        height: 281px;
        background: url('@/bottom.png');
      }
    }
  }
}
</style>
